import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import useEmployeeSearchInline, {
  useEmployeesByIds,
} from "@/queries/employees/use-employees.query.ts";
import { CustomFieldSelect, SelectItem } from "@skailer-com/uikit";
import { unionBy } from "lodash";
import { useMemo, useState } from "react";
import { useWatch } from "react-hook-form";

/** Ссылка на сотрудников: поиск и подгрузка выбранных — из API Skailer, сам список — uikit. */
export function CustomFieldEditEmployeeReference(props: CustomFieldRendererProps) {
  const { field, form, fieldValue } = props;
  const managerSearch = useEmployeeSearchInline();
  const selectedIds: number[] = useWatch({ control: form.control, name: field.slug }) ?? [];
  const [initiallySelectedIds] = useState<number[]>(selectedIds);
  const { data: selectedEmployees } = useEmployeesByIds(
    initiallySelectedIds,
    initiallySelectedIds.length > 0
  );
  const { renderEmployeeName } = useFormatter();

  const options = useMemo<SelectItem[]>(() => {
    const fieldValueOptions: SelectItem[] = (fieldValue?.value_employees ?? []).map((employee) => ({
      id: employee.id,
      title: renderEmployeeName(employee),
    }));
    const selectedOptions: SelectItem[] = (selectedEmployees ?? []).map((employee) => ({
      id: employee.id,
      title: renderEmployeeName(employee),
    }));
    const initialSelectedOptions = selectedOptions.filter((option) =>
      initiallySelectedIds.includes(option.id as number)
    );

    return unionBy<SelectItem>(
      fieldValueOptions,
      initialSelectedOptions,
      managerSearch.options,
      selectedOptions,
      "id"
    );
  }, [
    fieldValue?.value_employees,
    initiallySelectedIds,
    managerSearch.options,
    renderEmployeeName,
    selectedEmployees,
  ]);

  return (
    <CustomFieldSelect
      {...props}
      options={options}
      searchOptions={managerSearch.options}
      onSearchOptions={managerSearch.search}
      isLoading={managerSearch.isLoading}
      loadOptionsOnOpen
      showAvatar
    />
  );
}
